import { FieldMetaProps } from 'formik';

import { Messages } from 'config';

// Main answers every request from a signed-in user whose access the company
// owner revoked with 401 `{ message: 'AccountDeactivated' }`.
export const ACCOUNT_DEACTIVATED_CODE = 'AccountDeactivated';

export const isAccountDeactivatedError = (error: any) =>
  error?.response?.status === 401 &&
  error?.response?.data?.message === ACCOUNT_DEACTIVATED_CODE;

export const parseAxiosError = (error: any) => {
  if (
    error?.data &&
    typeof error.data === 'object' &&
    'message' in error.data
  ) {
    return error?.data?.message;
  }

  if (
    error?.response?.data &&
    typeof error.response.data === 'object' &&
    'message' in error.response.data
  ) {
    return error?.response?.data?.message;
  }

  return error?.message || 'Unknown error';
};

export const getErrorMessage = (error: any) => {
  if (typeof error === 'string') {
    return error;
  }

  if (
    'data' in error &&
    error.data &&
    typeof error.data === 'object' &&
    !Array.isArray(error.data)
  ) {
    if ('error' in error.data && typeof error.data.error === 'string') {
      return error.data.error;
    }

    if (
      'errors' in error.data &&
      Array.isArray(error.data.errors) &&
      error.data.errors.length > 0
    ) {
      const firstError = error.data.errors[0];

      if (
        firstError &&
        typeof firstError === 'object' &&
        'message' in firstError
      ) {
        return firstError.message;
      }

      return firstError;
    }
  }

  return (
    error?.response?.data?.error?.msg ||
    error?.response?.data?.debug?.message ||
    error?.message ||
    Messages.SOMETHING_WENT_WRONG
  );
};

export const controlError = <T = any>(
  meta: FieldMetaProps<T>,
  name: string,
  label?: string,
  controlErrorLabel?: boolean
) => {
  const error = meta && meta.touched && meta.error;
  if (!error || typeof error !== 'string' || error.length <= 1) {
    return undefined;
  }
  return controlErrorLabel ? error.replace(name, label || 'Value') : error;
};
